function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLidar4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "64.053 20.497 385.986 379.196",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 76.224,
    y: 31.386,
    width: 362.543,
    height: 169.101,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(255, 255, 255)",
      strokeWidth: 31
    },
    d: "M 146.682 212.017 L 109.531 383.681"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(255, 255, 255)",
      strokeWidth: 31
    },
    d: "M 254.292 214.579 L 251.73 384.961"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(216, 216, 216)",
      stroke: "rgb(255, 255, 255)",
      strokeWidth: 31
    },
    d: "M 360.621 208.175 L 391.366 382.4"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLidar4);
export default __webpack_public_path__ + "static/media/lidar4.ff94c33951f319c32a62fc43c57b199e.svg";
export { ForwardRef as ReactComponent };